export const wheelSoundEnabledChecker = ({ isWheelSpinSoundEnabled, isWheelButtonSoundEnabled, isWheelResultSoundEnabled, isenableWheelSound, updateSetting }) => {
  const setIfChanged = (key, currentValue, nextValue) => {
    if (currentValue !== nextValue) {
      updateSetting(key, nextValue);
    }
  };

  if (isenableWheelSound === undefined) {
    setIfChanged('enableWheelSound', isenableWheelSound, false);
    setIfChanged('isWheelSpinSoundEnabled', isWheelSpinSoundEnabled, false);
    setIfChanged('isWheelButtonSoundEnabled', isWheelButtonSoundEnabled, false);
    setIfChanged('isWheelResultSoundEnabled', isWheelResultSoundEnabled, false);
    return;
  }

  if (!isenableWheelSound) {
    setIfChanged('isWheelSpinSoundEnabled', isWheelSpinSoundEnabled, false);
    setIfChanged('isWheelButtonSoundEnabled', isWheelButtonSoundEnabled, false);
    setIfChanged('isWheelResultSoundEnabled', isWheelResultSoundEnabled, false);
    return;
  }

  if (isWheelSpinSoundEnabled || isWheelButtonSoundEnabled || isWheelResultSoundEnabled) {
    setIfChanged('enableWheelSound', isenableWheelSound, true);
  }
  if (!isWheelSpinSoundEnabled && !isWheelButtonSoundEnabled && !isWheelResultSoundEnabled) {
    setIfChanged('enableWheelSound', isenableWheelSound, false);
  }
};
